/**
 * SMB Component - Unmanaged Trial
 * @copyright 2019 AVAST Software s.r.o.
 * @author Erik Ondrus
 * @version 1.0
 * @since 2019-08
 *
 * DESCRIPTION:
 * Basic functionality of unmanaged Trial
 *
 * OPTIONS:
 *
 *
 * USAGE EXAMPLE:
 * <a href="#" data-role="download-link" data-sku="bug.100.1m"...>free trial</a>
 *
 */

'use strict';

$(document).ready(function() {
	var skuInit =
		$('.vue-trial-button')
			.first()
			.attr('data-sku') || 'bus.100.1m'; // hotfix-test sku

	var productNames = {
		bus: 'Avast Business Standalone Antivirus',
		bug: 'Avast Business Standalone Antivirus Pro',
		bup: 'Avast Business Standalone Antivirus Pro Plus'
	}

	$('[data-overlay="trialform"] .trial-form').load('smb-trial-unmanaged2018-form?sku=' + skuInit, function() {
		initAvastForm();
	});

	$('[data-role="download-link"]').click(function(e) {
		var sku = $(this).attr('data-sku');
		$('.trial-form input[name="sku"]').val(sku);
		$('.js-product-name-placeholder').text(getProductName(sku));
	});

	function getProductName(sku) {
		var id = sku.slice(0, 3);
		return productNames[id] || 'Avast Business Trial';
	}	
});
